import Head from 'next/head';
import FAQPage from '../../src/containers/FAQPage';
// const HomeownersLandingPage = dynamic(() => import('../../src/containers/HomeownersLandingPage'));

const FAQQuestion = (props) => {
  const getPageTitle = () => {
    return `Zorba | Frequently asked questions`;
  };
  const getPageDescription = () => {
    return 'Occasional questions for answers to questions we often help our customers with.';
  };
  return (
    <>
      <Head>
        <title>{getPageTitle()}</title>
        <meta key="og:title" property="og:title" content={getPageTitle()} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={getPageTitle()}
        />
        <meta
          key="description"
          name="description"
          content={getPageDescription()}
        />
        <meta
          key="og:description"
          property="og:description"
          content={getPageDescription()}
        />
        <meta
          key="keywords"
          name="keywords"
          content={`off-market properties,investment properties for sale,fsbo,distressed properties`}
        />
      </Head>
      <FAQPage />
    </>
  );
};

export default FAQQuestion;
